package br.com.vvrefeicoes.portal.core.ui.components

import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.ElevatedButton
import androidx.compose.material3.FilledTonalButton
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes

enum class PortalButtonVariant {
    Filled,
    Outlined,
    Text,
    Elevated,
    Secondary,
    Accent,
    Danger,
}

@Composable
fun AppButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    variant: PortalButtonVariant = PortalButtonVariant.Filled,
    leadingIcon: ImageVector? = null,
) {
    val content: @Composable RowScope.() -> Unit = {
        if (leadingIcon != null) {
            Icon(
                imageVector = leadingIcon,
                contentDescription = null,
                modifier = Modifier.size(ButtonDefaults.IconSize),
            )
            Spacer(Modifier.width(ButtonDefaults.IconSpacing))
        }
        Text(text = text, style = MaterialTheme.typography.labelLarge)
    }
    when (variant) {
        PortalButtonVariant.Filled ->
            Button(onClick, modifier, enabled, shape = AppShapes.medium, content = content)
        PortalButtonVariant.Outlined ->
            OutlinedButton(onClick, modifier, enabled, shape = AppShapes.medium, content = content)
        PortalButtonVariant.Text ->
            TextButton(onClick, modifier, enabled, shape = AppShapes.medium, content = content)
        PortalButtonVariant.Elevated ->
            ElevatedButton(onClick, modifier, enabled, shape = AppShapes.medium, content = content)
        PortalButtonVariant.Secondary ->
            FilledTonalButton(onClick, modifier, enabled, shape = AppShapes.medium, content = content)
        PortalButtonVariant.Accent ->
            Button(
                onClick,
                modifier,
                enabled,
                shape = AppShapes.medium,
                colors =
                    ButtonDefaults.buttonColors(
                        containerColor = MaterialTheme.colorScheme.tertiary,
                        contentColor = Color.White,
                    ),
                content = content,
            )
        PortalButtonVariant.Danger ->
            Button(
                onClick,
                modifier,
                enabled,
                shape = AppShapes.medium,
                colors =
                    ButtonDefaults.buttonColors(
                        containerColor = MaterialTheme.colorScheme.error,
                        contentColor = MaterialTheme.colorScheme.onError,
                    ),
                content = content,
            )
    }
}
